import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postSentraSalaryRowsV2 = async (salaryData, businessId) => {
  const apiPath = `business/${businessId}/sentra-salary-data-v2`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: salaryData,
  });

  const response = await axios(signedRequest);

  return response.data;
};
